import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

// --- FIX 1: Update the prop interface to expect an array of objects ---
interface TranscriptTurn {
  speaker_role: string;
  text: string;
}

interface SessionTranscriptViewProps {
  transcript: TranscriptTurn[] | string; // Can be the array or the fallback string
}

const SessionTranscriptView: React.FC<SessionTranscriptViewProps> = ({ transcript }) => {
  const { toast } = useToast();

  const handleCopy = async () => {
    // --- FIX 2: Format the array into a string before copying ---
    let textToCopy = "";
    if (Array.isArray(transcript)) {
      textToCopy = transcript
        .map(turn => `${turn.speaker_role}: ${turn.text}`)
        .join("\n\n"); // Join turns with a double newline for readability
    } else {
      textToCopy = transcript;
    }

    try {
      await navigator.clipboard.writeText(textToCopy);
      toast({
        title: "Copied to clipboard",
        description: "Session transcript has been copied to your clipboard.",
      });
    } catch (error) {
      toast({
        title: "Copy failed",
        description: "Unable to copy transcript to clipboard.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-bold">Session Transcript</h3>
        <Button variant="outline" size="sm" onClick={handleCopy}>
          <Copy className="h-4 w-4 mr-2" />
          Copy Transcript
        </Button>
      </div>
      
      <Card>
        <CardContent className="p-6">
          <div className="bg-gray-50 rounded-lg p-4 max-h-[60vh] overflow-y-auto">
            <div className="font-mono text-sm leading-relaxed space-y-4">
              {/* --- FIX 3: Map over the array to render each turn correctly --- */}
              {Array.isArray(transcript) && transcript.length > 0 ? (
                transcript.map((turn, index) => (
                  <div key={index}>
                    <span className="font-semibold text-gray-800">{turn.speaker_role}:</span>
                    <span className="text-gray-700 ml-2">{turn.text}</span>
                  </div>
                ))
              ) : (
                // Render the fallback text if the transcript is not a valid array
                <p>{transcript || "No transcript available"}</p>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SessionTranscriptView;